module.exports = __webpack_public_path__ + "img/shadow-sm-portrait-150.6c48b82.png";